import {ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {BehaviorSubject, Subject} from 'rxjs';
import {Avatar, IMessengerConnector} from '../../../types/all.type';
import {NzUploadFile} from 'ng-zorro-antd/upload';
import {InterfaceService} from '../../../services/interface.service';
import {TelegramService} from '../../../pages/page-telegram/telegram.service';
import {takeUntil} from 'rxjs/operators';
import {AllService} from '../../../services/all.service';

@Component({
  selector: 'app-profile-avatar',
  templateUrl: './profile-avatar.component.html',
  styleUrls: ['./profile-avatar.component.scss']
})
export class ProfileAvatarComponent implements OnInit, OnDestroy {
  @Output() reloadProfile = new EventEmitter<void>();
  private destroy$: Subject<void> = new Subject();
  @Input() Service: IMessengerConnector;
  isUploadAvatar = false;
  private avatars: BehaviorSubject<Avatar[]> = new BehaviorSubject([]);
  public avatars$ = this.avatars.asObservable();
  public isLoaded$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  get avatarHeaders(): any {
    return {authorization: 'Token ' + this.Service.token};
  }

  get uploadUrl(): string {
    return this.Service.urlApi + '/api/telegram/profile/avatar/';
  }

  constructor(
    public allService: AllService,
    private cd: ChangeDetectorRef,
    private interfaceService: InterfaceService,
  ) {
  }

  ngOnInit(): void {
    this.Service.getProfile$.pipe().subscribe(() => {
      this.cd.detectChanges();
    });
    this.interfaceService.profileSetService$.pipe(takeUntil(this.destroy$)).subscribe((type) => {
      this.avatars.next([]);
      this.loadAvatars();
      this.cd.detectChanges();
    });
  }
  resetSlider(): void {
    this.isLoaded$.next(false);
    setTimeout(() => {
      this.isLoaded$.next(true);
    });
  }
  handleChangeAvatar(info: { file: NzUploadFile }): void {
    switch (info.file.status) {
      case 'uploading':
        this.isUploadAvatar = true;
        break;
      case 'done':
        // Get this url from response in real world.
        this.reloadProfile.next();
        this.loadAvatars();
        break;
      case 'error':
        const error_id = info?.file?.error?.error?.error_id;
        if (error_id) {
          this.interfaceService.errorHandling(error_id);
        }
        this.isUploadAvatar = false;
        break;
    }
  }

  loadAvatars() {
    if (this.Service instanceof TelegramService) {
      this.Service.getAvatars().pipe(takeUntil(this.destroy$)).subscribe((res) => {
        this.avatars.next(res.results.filter((v) => v.file_unique_id !== this.Service.arProfile?.avatar_file_unique_id));
        this.isLoaded$.next(true);
        this.resetSlider();
        this.cd.detectChanges();
      }, error => {
        this.avatars.next([]);
        this.resetSlider();
        this.cd.detectChanges();
      });
    } else {
      this.avatars.next([]);
      this.isLoaded$.next(true);
      this.resetSlider();
      this.cd.detectChanges();
      console.error('loadAvatars no telegram');
    }
  }

  removeAvatar(avatar: Avatar) {
    if (this.Service instanceof TelegramService) {
      this.Service.removeAvatar(avatar.file_id).pipe(takeUntil(this.destroy$)).subscribe((res) => {
        this.loadAvatars();
        this.cd.detectChanges();
      }, error => {
        this.interfaceService.errorHandling(error, true, this.Service);
      });
    }
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
